const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.stage_disciplines/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.stage_disciplines/LIST_STAGE_DISCIPLINES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
